export default "__VITE_ASSET__BBVDCOMU__"